// extracted by mini-css-extract-plugin
export default {"addToCartControl":"ZY-z","giftCard":"_Y-z","btnContainer":"aZ-z","cartButton":"bZ-z","disabled":"cZ-z"};